
<div class="sc-textarea">
  <div>
    @if (scLabel) {
      <label class="input-label">
        {{ scLabel }}
        <span class="sc-required sc-required-star"></span>
      </label>
    }
  </div>

  <textarea [(ngModel)]="value"
    [disabled]="isDisabled"
    [readOnly]= "scIsReadonly"
    class="sc-text-area"
    [rows]="scRows"
    [cols]="scCols"
    (blur)="onBlur($event)"
    [attr.placeholder]="scPlaceholder"
    (ngModelChange)="onModelChange($event)"
  [style.width]="scWidth"></textarea>
</div>
@if (!scHideValidationMessage && !isValid) {
  <p class="sc-error-message">{{ validationMessage }}</p>
}

